import { render, staticRenderFns } from "./RankingBoard.vue?vue&type=template&id=590de854&scoped=true&"
import script from "./RankingBoard.vue?vue&type=script&lang=js&"
export * from "./RankingBoard.vue?vue&type=script&lang=js&"
import style0 from "./RankingBoard.vue?vue&type=style&index=0&id=590de854&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590de854",
  null
  
)

export default component.exports